/** "Peanuts", "Peanuts and Soy", "Peanuts, Soy and Wheat": the facility statement's list. */
export const listAllergens = (names: string[]) => {
  if (names.length < 2) return names.join("");

  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};
